import React, { useContext, useEffect, useState } from "react";
import {Route, Switch, useParams} from "react-router-dom";
import { socketContext } from "../../App";
import EnrollAudition from "../../components/Pages/AuditionPages/EnrollAudition/EnrollAudition";
import Chatting from "../../components/Pages/Chatting/Chatting";

import ActivitiesBody from "../../components/Layouts/Sidebar/Left/Activities/ActivitiesBody";

import LivePost from "../../components/Right/LiveContent";

import ActivitiesLearnNav from "../../components/Pages/LearningPages/LearningSession/ActivitiesLearnNav";
import Market from "../../Screen/MarketPlace/MarketPlace";

import LeftSidebar from "./Sidebar/LeftSidebar";
import RightSidebar from "./Sidebar/RightSidebar";

import "../../Screen/Post/NewPost.css";

import GuestHome from "../../Screen/GuestHome";
import AuditionBody from "../Pages/AuditionPages/AuditonBody/AuditionBody";
import VideoHome from "../../Screen/VideoHome";

import VideoActivities from "./Sidebar/Left/Activities/Content/VideoActivities";

import Category from "../../Screen/Category/Category";
import CategoryView from "./Sidebar/Left/Category/Content/CategoryView";
import ProfileCatBody from "./Sidebar/Left/Category/Content/ProfileCatBody";
import SettingsHome from "../../Screen/SettingsHome";
import FollowingMap from "../../Screen/FollowingMap";
import FanGroup from "./Sidebar/Left/FanGroup/FanHome";
import Navigation from "./Header/Navigation";
import UpcomingLive from "../../Screen/Right/UpcomingLive";
import Learn from "../../Screen/Right/Learn";
import Meetup from "../../Screen/Right/Meetup";
import Qna from "../../Screen/Right/Qna";
import UpcomingAuditions from "../../Screen/Right/UpcomingAuditions";
import PromoVideo from "../PromoVideo/PromoVideo";
import {Helmet} from "react-helmet";

const GuestMasterLayout = () => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const socketData = useContext(socketContext);


  useEffect(() => {
    // socketData.on("getUsers", (users) => {
    //   setOnlineUsers(users);
    // });
  }, []);

  return (
    <React.Fragment>
      <Navigation />
      <div className="homebody ">
        <div className="container-fluid ContainerMobilePost">
          <div className="row d-flex PostRow  ">
            <div className="col-md-3 justify-content-center TabLeftSide individual-scroll desktop-view Left-max-width">
              <div className="promoVideoBorder left-col-box-promo-video ">
                <PromoVideo />
              </div>
              <LeftSidebar onlineUserProp={onlineUsers} />
            </div>
            <div className="col-md-6 justify-content-center TabMiddle PostCardWidthMobile Center-max-width">
              <Switch>
                <Route exact path="/guest_mode/:slug" component={GuestHome} />
                <Route exact path="/guest_mode/" component={GuestHome} />
                <Route exact path="/video" component={VideoHome} />
                <Route exact path="/marketplace" component={Market} />
                <Route exact path="/chatting/:id" component={Chatting} />

                <Route exact path="/category" component={Category} />
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/category-view/:slug"*/}

                {/*  component={CategoryView}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/category-profile/:slug"*/}
                {/*  component={ProfileCatBody}*/}
                {/*/>*/}

                {/*<Route exact path="/activities" component={ActivitiesBody} />*/}
                {/* <Route exact path="/learning-activities/:slug" component={ActivitiesLearnNav} />
                <Route exact path="/learning-activities" component={ActivitiesLearnNav} /> */}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/activities/video/:id"*/}
                {/*  component={VideoActivities}*/}
                {/*/>*/}
                {/* <Route
                  exact
                  path="/category-view/:slug"
                  component={CategoryView}
                />

                <Route
                  exact
                  path="/category-profile/:slug"
                  component={ProfileCatBody}
                /> */}

                {/*<Route exact path="/following" component={FollowingMap} />*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/learning-activities/:slug"*/}
                {/*  component={ActivitiesLearnNav}*/}
                {/*/>*/}

                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/learning-activities"*/}
                {/*  component={ActivitiesLearnNav}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/activities/video/:id"*/}
                {/*  component={VideoActivities}*/}
                {/*/>*/}
                {/*<Route exact path="/fan-group" component={FanGroup} />*/}

                {/*/!* Right Sidebar   *!/*/}
                {/*<Route exact path="/live-now" component={LivePost} />*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/upcoming-learning-sessions"*/}
                {/*  component={Learn}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/upcoming-live-chat"*/}
                {/*  component={UpcomingLive}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/upcoming-auditions"*/}
                {/*  component={UpcomingAuditions}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/upcoming-meetup-events"*/}
                {/*  component={Meetup}*/}
                {/*/>*/}
                {/*<Route exact path="/upcoming-qna-events" component={Qna} />*/}
                {/*<Route exact path="/settings" component={SettingsHome} />*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/enrolled-auditions"*/}
                {/*  component={EnrollAudition}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/enrolled-auditions-round/:slug"*/}
                {/*  component={AuditionBody}*/}
                {/*/>*/}
                {/*<Route*/}
                {/*  exact*/}
                {/*  path="/enrolled-auditions"*/}
                {/*  component={EnrollAudition}*/}
                {/*/>*/}

                {/* Right Sidebar End */}
              </Switch>
            </div>

            <div className="col-md-3 justify-content-center Right-max-width container-fluid RightSideContent individual-scroll">
              <RightSidebar />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GuestMasterLayout;
